var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NoData',{staticClass:"no-data-overlay",class:_vm.classList,attrs:{"message":_vm.message,"errorMessage":_vm.errorMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }